var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.32 5.33106L15.32 3.33106H15.25C15.2035 3.32638 15.1566 3.32638 15.11 3.33106H14.88H14.75H14.68L9 5.28106L3.32 3.33106C3.16962 3.28147 3.00961 3.26831 2.85314 3.29265C2.69667 3.31698 2.54822 3.37813 2.42 3.47106C2.29076 3.56308 2.18527 3.68452 2.11224 3.82537C2.03921 3.96621 2.00074 4.12241 2 4.28106V18.2811C1.99946 18.4907 2.06482 18.6952 2.18685 18.8657C2.30887 19.0362 2.48138 19.164 2.68 19.2311L8.68 21.2311C8.88145 21.2967 9.09856 21.2967 9.3 21.2311L15 19.3311L20.68 21.2811C20.7862 21.2955 20.8938 21.2955 21 21.2811C21.2091 21.284 21.4132 21.2171 21.58 21.0911C21.7092 20.999 21.8147 20.8776 21.8878 20.7368C21.9608 20.5959 21.9993 20.4397 22 20.2811V6.28106C22.0005 6.07142 21.9352 5.8669 21.8132 5.69643C21.6911 5.52596 21.5186 5.39815 21.32 5.33106ZM8 18.8911L4 17.5611V5.67106L8 7.00106V18.8911ZM14 17.5611L10 18.8911V7.00106L14 5.67106V17.5611ZM20 18.8911L16 17.5611V5.67106L20 7.00106V18.8911Z",
    fill: "#B891A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map-icon.3d0c345ec48e3d7cf9ace508e17ff4aa.svg";
export { ForwardRef as ReactComponent };